export const DEMO_CREDENTIALS = { email: "demo@publisher.com", password: "demo1234" };

export const PUBLISHER = {
  name: "Michael Carter",
  company: "Carter Media Group LLC",
  email: "demo@publisher.com",
  phone: "+1 (305) 555-0148",
  id: "PUB-10482",
  country: "United States",
  sources: ["Google Ads", "Meta Ads", "SEO", "GMB"],
  payoutTerms: "Weekly Net 7",
  payoutMethod: "Wire Transfer",
  bank: "Chase Bank •••• 4821",
  manager: "Abid Ali",
  joined: "Mar 12, 2024",
  tier: "Gold",
};

export const KPIS = {
  today: { calls: 142, qualified: 118, earnings: 6840 },
  week: { calls: 1086, qualified: 912, earnings: 51260 },
  month: { calls: 4318, qualified: 3694, earnings: 212480 },
  nextPayout: { amount: 51260, date: "Jun 22, 2026" },
  qualityScore: 96,
};

export const DAILY_CALLS = [
  { day: "Jun 9", calls: 128, qualified: 108 },
  { day: "Jun 10", calls: 141, qualified: 119 },
  { day: "Jun 11", calls: 156, qualified: 132 },
  { day: "Jun 12", calls: 149, qualified: 127 },
  { day: "Jun 13", calls: 167, qualified: 142 },
  { day: "Jun 14", calls: 138, qualified: 118 },
  { day: "Jun 15", calls: 172, qualified: 149 },
  { day: "Jun 16", calls: 164, qualified: 140 },
  { day: "Jun 17", calls: 181, qualified: 155 },
  { day: "Jun 18", calls: 176, qualified: 150 },
  { day: "Jun 19", calls: 190, qualified: 163 },
  { day: "Jun 20", calls: 185, qualified: 158 },
  { day: "Jun 21", calls: 142, qualified: 118 },
];

export const MY_OFFERS = [
  { id: "OFR-201", name: "Plumbing — Nationwide", vertical: "Plumbing", payout: 65, buffer: "120 sec", hours: "24/7", states: "All 48 States", did: "+1 (888) 412-7701", status: "Live", calls: 1284 },
  { id: "OFR-214", name: "HVAC Repair — Premium", vertical: "HVAC", payout: 85, buffer: "120 sec", hours: "7AM – 9PM EST", states: "TX, FL, AZ, GA, NC", did: "+1 (888) 412-7714", status: "Live", calls: 1102 },
  { id: "OFR-233", name: "Water Damage Restoration", vertical: "Water Damage", payout: 140, buffer: "120 sec", hours: "24/7", states: "All 48 States", did: "+1 (888) 412-7733", status: "Live", calls: 846 },
  { id: "OFR-247", name: "Roofing — Storm Repair", vertical: "Roofing", payout: 95, buffer: "120 sec", hours: "8AM – 8PM EST", states: "TX, OK, FL, LA", did: "+1 (888) 412-7747", status: "Paused", calls: 412 },
  { id: "OFR-259", name: "Appliance Repair", vertical: "Appliance Repair", payout: 45, buffer: "120 sec", hours: "8AM – 7PM EST", states: "All 48 States", did: "+1 (888) 412-7759", status: "Live", calls: 674 },
];

export const AVAILABLE_OFFERS = [
  { id: "OFR-301", name: "Solar Installation — Residential", vertical: "Solar", payout: 120, hours: "9AM – 7PM EST", states: "CA, AZ, NV, TX, FL", exclusive: true },
  { id: "OFR-305", name: "Electrician — Emergency", vertical: "Electrician", payout: 70, hours: "24/7", states: "All 48 States" },
  { id: "OFR-312", name: "Home Security Systems", vertical: "Home Security", payout: 110, hours: "8AM – 10PM EST", states: "All 48 States", exclusive: true },
  { id: "OFR-318", name: "Pest Control", vertical: "Pest Control", payout: 55, hours: "8AM – 6PM EST", states: "Southern States" },
  { id: "OFR-324", name: "Garage Door Repair", vertical: "Garage Door", payout: 60, hours: "24/7", states: "All 48 States" },
  { id: "OFR-331", name: "Tree Removal Services", vertical: "Tree Services", payout: 75, hours: "7AM – 7PM EST", states: "All 48 States" },
];

export const PAYOUTS = [
  { id: "INV-2026-0612", period: "Jun 8 – Jun 14, 2026", calls: 884, amount: 49720, terms: "Weekly Net 7", status: "Processing", date: "Jun 21, 2026" },
  { id: "INV-2026-0605", period: "Jun 1 – Jun 7, 2026", calls: 861, amount: 47915, terms: "Weekly Net 7", status: "Paid", date: "Jun 14, 2026" },
  { id: "INV-2026-0529", period: "May 25 – May 31, 2026", calls: 902, amount: 50340, terms: "Weekly Net 7", status: "Paid", date: "Jun 7, 2026" },
  { id: "INV-2026-0522", period: "May 18 – May 24, 2026", calls: 846, amount: 46880, terms: "Weekly Net 7", status: "Paid", date: "May 31, 2026" },
  { id: "INV-2026-0515", period: "May 11 – May 17, 2026", calls: 873, amount: 48210, terms: "Weekly Net 7", status: "Paid", date: "May 24, 2026" },
  { id: "INV-2026-0508", period: "May 4 – May 10, 2026", calls: 819, amount: 45360, terms: "Weekly Net 7", status: "Paid", date: "May 17, 2026" },
];

const STATES = ["FL", "TX", "AZ", "GA", "NC", "CA", "OH", "NY"];
const OFFER_NAMES = MY_OFFERS.map((o) => [o.name, o.payout]);
export const CALL_LOG = Array.from({ length: 24 }, (_, i) => {
  const [offer, payout] = OFFER_NAMES[i % OFFER_NAMES.length];
  const secs = 150 + ((i * 97) % 520);
  const notQualified = i % 9 === 4;
  const dur = notQualified ? 48 + (i % 40) : secs;
  return {
    id: `CL-${88420 - i}`,
    time: `Jun 21, ${String(9 + Math.floor(i / 3)).padStart(2, "0")}:${String((i * 7) % 60).padStart(2, "0")}`,
    caller: `(${300 + ((i * 37) % 600)}) ***-${String(1000 + ((i * 431) % 9000)).slice(0, 4)}`,
    state: STATES[i % STATES.length],
    offer,
    duration: `${Math.floor(dur / 60)}:${String(dur % 60).padStart(2, "0")}`,
    status: notQualified ? "Below Buffer" : "Paid",
    payout: notQualified ? 0 : payout,
  };
});

export const QUALITY = {
  score: 96,
  checks: [
    "AI Fraud Detection",
    "Non-US Accent Screening",
    "IVR / Robot Detection",
    "Spam & Robocall Filtering",
    "Duplicate Caller Check",
    "Call Intent Verification",
  ],
  tips: [
    "Your Water Damage traffic converts 18% above network average — consider scaling budget.",
    "Keep ad copy matched to offer hours to maximise qualified call rate.",
    "Use call extensions on Google Ads for higher-intent callers.",
  ],
};

export const ANNOUNCEMENTS = [
  { date: "Jun 20, 2026", tag: "New Offer", title: "Solar Installation — $120/call now live", body: "Exclusive residential solar campaign open for CA, AZ, NV, TX and FL. Apply from the Offers tab." },
  { date: "Jun 17, 2026", tag: "Payout", title: "Weekly payouts processed on schedule", body: "All Weekly Net 7 payouts for Jun 1 – Jun 7 have been sent. Check Payouts for your invoice." },
  { date: "Jun 12, 2026", tag: "Update", title: "HVAC Premium payout increased to $85", body: "Thanks to strong buyer demand, HVAC Premium now pays $85 per qualified call." },
  { date: "Jun 5, 2026", tag: "Policy", title: "Reminder: 120-second post-IVR buffer", body: "Calls are qualified after 120 seconds post-IVR. Calls under the buffer are not billable." },
];

export const TICKETS = [
  { id: "TCK-3091", subject: "Request higher cap on Water Damage", status: "Open", updated: "Jun 20, 2026" },
  { id: "TCK-3054", subject: "Tracking number for new Meta campaign", status: "Resolved", updated: "Jun 14, 2026" },
  { id: "TCK-2988", subject: "Invoice INV-2026-0515 copy", status: "Resolved", updated: "May 26, 2026" },
];

export const CHAT = [
  { from: "manager", text: "Hi Michael, your Water Damage calls are performing great this week!", time: "10:14 AM" },
  { from: "me", text: "Thanks! Can we raise the daily cap on that offer?", time: "10:16 AM" },
  { from: "manager", text: "Yes — I've requested 150 calls/day from the buyer. I'll confirm by end of day.", time: "10:19 AM" },
];

export const DOCUMENTS = [
  { name: "W-9 Tax Form", type: "Tax", status: "Approved", date: "Mar 12, 2024" },
  { name: "Publisher Agreement", type: "Contract", status: "Signed", date: "Mar 12, 2024" },
  { name: "Google Ads — Plumbing Screenshots (3)", type: "Proof of Work", status: "Approved", date: "Apr 2, 2026" },
  { name: "Meta Ads — HVAC Screenshots (3)", type: "Proof of Work", status: "Approved", date: "May 9, 2026" },
  { name: "Bank Verification Letter", type: "Payment", status: "Approved", date: "Mar 15, 2024" },
];

export const money = (n) => `$${n.toLocaleString("en-US")}`;
